import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { collection, doc, getDoc, onSnapshot } from 'firebase/firestore'
import { db } from '../firebaseConfig'

function formatDate(ts) {
  return ts?.toDate ? ts.toDate().toLocaleString('id-ID') : '-'
}

export default function ChatViewerPage() {
  const { orderId } = useParams()

  const [chatInfo, setChatInfo] = useState(null)
  const [messages, setMessages] = useState([])
  const [userName, setUserName] = useState('-')
  const [therapistName, setTherapistName] = useState('-')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const loadChat = async () => {
      try {
        const chatRef = doc(db, 'chats', `order_${orderId}`)
        const chatSnap = await getDoc(chatRef)

        if (!chatSnap.exists()) {
          setLoading(false)
          return
        }

        const chatData = chatSnap.data()
        setChatInfo(chatData)

        // STOP loading lebih awal
        setLoading(false)

        // ----- Ambil user & terapis paralel -----
        const userRef = doc(db, 'users', chatData.userId)
        const therapistRef = doc(db, 'therapists', chatData.therapistId)

        Promise.all([getDoc(userRef), getDoc(therapistRef)]).then(([u, t]) => {
          if (u.exists()) {
            const d = u.data()
            setUserName(d.name || d.fullName || d.username || 'User')
          }
          if (t.exists()) {
            const d = t.data()
            setTherapistName(d.name || d.fullName || d.displayName || 'Terapis')
          }
        })

        // ----- Real-time chat -----
        const msgRef = collection(chatRef, 'messages')
        const unsub = onSnapshot(msgRef, (snap) => {
          const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }))
          list.sort(
            (a, b) => (a.timestamp?.seconds || 0) - (b.timestamp?.seconds || 0)
          )
          setMessages(list)
        })

        return () => unsub()
      } catch (err) {
        console.log('ERR:', err)
      }
    }

    loadChat()
  }, [orderId])

  if (loading) {
    return React.createElement(
      'div',
      { className: 'p-5 text-white' },
      'Loading chat...'
    )
  }

  if (!chatInfo) {
    return React.createElement(
      'div',
      { className: 'p-5 text-white' },
      `Chat untuk order ${orderId} tidak ditemukan`
    )
  }

  return React.createElement('div', { className: 'p-5 text-white space-y-4' }, [
    React.createElement(
      'h1',
      { className: 'text-2xl font-bold', key: 't' },
      `Chat: Order ${orderId}`
    ),

    React.createElement(
      'div',
      {
        key: 'info',
        className:
          'p-4 bg-gray-800 rounded-lg border border-gray-700 space-y-1',
      },
      [
        React.createElement('p', { key: 'u' }, `User: ${userName}`),
        React.createElement('p', { key: 't' }, `Terapis: ${therapistName}`),
        React.createElement(
          'p',
          { key: 'lm' },
          `Last Message: ${chatInfo.lastMessage || '-'}`
        ),
        React.createElement(
          'p',
          { key: 'lt' },
          `Last Timestamp: ${formatDate(chatInfo.lastTimestamp)}`
        ),
      ]
    ),

    React.createElement(
      'h2',
      { key: 'title', className: 'text-xl font-semibold' },
      'Percakapan'
    ),

    React.createElement(
      'div',
      { key: 'msgs', className: 'space-y-3 max-h-[70vh] overflow-y-auto pr-3' },

      messages.map((msg) => {
        const isUser = msg.senderType === 'user'
        const align = isUser ? 'self-start' : 'self-end'
        const bubble = isUser ? 'bg-gray-800' : 'bg-blue-700'
        const sender = isUser ? userName : therapistName

        return React.createElement(
          'div',
          { key: msg.id, className: `flex ${align}` },
          [
            React.createElement(
              'div',
              {
                key: 'bubble',
                className: `p-3 rounded-lg border border-gray-700 max-w-[70%] ${bubble}`,
              },
              [
                React.createElement(
                  'p',
                  { key: 's', className: 'text-xs text-gray-300 mb-1' },
                  sender
                ),
                React.createElement(
                  'p',
                  { key: 't', className: 'text-white whitespace-pre-wrap' },
                  msg.text
                ),
                React.createElement(
                  'p',
                  { key: 'tm', className: 'text-[10px] text-gray-400 mt-1' },
                  formatDate(msg.timestamp)
                ),
              ]
            ),
          ]
        )
      })
    ),
  ])
}
